import * as types from 'legacy-src/constants/types';
import { isEmpty } from 'lodash';
import { getActiveSubject } from './subject';

const studentsBySection = (state = false, action) => {
  switch (action.type) {
    case types.STUDENTS_BY_SECTION:
      const { userData, params } = action;
      const activeSubject = getActiveSubject(userData, params);
      if (isEmpty(activeSubject)) {
        return {};
      }

      const { classes } = activeSubject;

      const studentsBySection = classes.reduce((acc, currentClass) => {
        acc[parseInt(currentClass.id, 10)] = currentClass.students.map(
          (student) => ({
            ...student,
            id: parseInt(student.id, 10),
          }),
        );
        return acc;
      }, {});

      return studentsBySection;
  }

  return state;
};

export default studentsBySection;
